import { useNotificationsStore } from '@/store/notification.ts';
import { TransportationTypes } from '@/types/base-model.ts';
import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";

export const useActivityStore = defineStore("activity", () => {

    const isActivityRunning = ref(false);
    const groupSize = ref(1);
    const dog = ref(true);
    const transportation = ref<TransportationTypes>("bike");

    const notificationStore = useNotificationsStore();

    const showActivityRunningBanner = computed(() => {
        return isActivityRunning.value && !notificationStore.isInsideFence && !notificationStore.isPositionInaccurate;
    });

    const showInsideFenceBanner = computed(() => {
        return isActivityRunning.value && notificationStore.isInsideFence && !notificationStore.isPositionInaccurate;
    });

    const showInaccuracyBanner = computed(() => {
        return notificationStore.isPositionInaccurate && isActivityRunning.value;
    });

    const currentRadius = computed(() => {
        let radius = 0;
        if (dog.value) {
            radius += 30;
        }
        switch (transportation.value) {
            case "bike":
                radius += 50;
                break;
            case "foot":
                radius += 0;
                break;
            case "mountainbike":
                radius += 100;
                break;
            case "horse":
                radius += 50;
                break;
            case "winter-activity":
                radius += 100;
                break;
        }
        radius += groupSize.value * 2;
        return radius;
    });

    const setGroupSize = (size: number) => {
        groupSize.value = size;
    };

    const setDog = (hasDog: boolean) => {
        dog.value = hasDog;
    };

    const setTransportation = (mode: TransportationTypes) => {
        transportation.value = mode;
    };

    watch(isActivityRunning, async (running) => {
        if (running) {
            await notificationStore.requestNotificationPermissions();
            notificationStore.startWatch();
        } else {
            notificationStore.stopWatch();
        }
    });

    return {
        isActivityRunning,
        showActivityRunningBanner,
        showInsideFenceBanner,
        setGroupSize,
        setDog,
        setTransportation,
        groupSize,
        dog,
        transportation,
        currentRadius,
        showInaccuracyBanner
    };
});